import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Box, TextField, Autocomplete, FormControlLabel, Tooltip, Zoom, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import host from "../host";
import MessageSnackbar from "../_layout/elements/snackbar";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";

export default function ShareChat(props) {
  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
    width: 38,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#00bdd6" : "#00bdd6",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#00bdd6" : "#00bdd6",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const handlePrivacyToggle = () => {
    setLinkGenerated(false);
    setShareLink("");
    setChecked([]);
    setStatus(status === "public" ? "private" : "public");
  };
  const [checked, setChecked] = React.useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const handleToggle = (selectedUsers) => {
    const selectedUserIds = selectedUsers.map((user) => user.id);
    setChecked(selectedUserIds);
  };

  const [allUsers, setAllUsers] = useState([]);
  const [linkGenerated, setLinkGenerated] = useState(false);
  const [status, setStatus] = useState("private");
  const [shareId, setShareId] = useState("");
  const [shareLink, setShareLink] = useState("");

  const getUsers = () => {
    fetch(host.chaturl + "/user/list", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        const temp = data.map((item) => {
          return { label: item.email, id: item._id };
        });

        setAllUsers(temp);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getShareId = (link) => {
    const url = link;
    const parts = url.split("/");
    const id = parts[parts.length - 1];
    setShareId(id);
  };

  const generateLink = () => {
    //  if(checked.length === 0 && status === "public"){
    //      setSeverity("error");
    //      setMessage("Please select atleast one user");
    //      setSnackbar(true);
    //      return;
    //  }

    let payload = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(checked),
    };
    if (status === "public" && checked.length === 0) {
      payload = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
    }
    fetch(host.chaturl + `/share?chat_id=${props?.chatId}&is_public=${status === "public" ? "true" : "false"}`, payload)
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else if (res.status === 403) {
          dispatch(changeAuth(false, null));
          navigate("/logout");
        } else {
          setSeverity("error");
          setMessage("Something went wrong");
          setSnackbar(true);
        }
      })
      .then((data) => {
        setLinkGenerated(true);
        getShareId(data.link);
        setShareLink(data.link);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const copyLink = () => {
    navigator.clipboard.writeText(shareLink);
    setSeverity("success");
    setMessage("Link copied to clipboard");
    setSnackbar(true);
  };

  const getTruncatedText = (text, limit) => {
    if (text.length > limit) {
      return text.substring(0, limit) + "...";
    }
    return text;
  };

  const handleReset = () => {
    setChecked([]);
    setLinkGenerated(false);
    setShareLink("");
  };

  useEffect(() => {
    handleReset();
  }, [props?.opensharechat]);

  useEffect(() => {
    if (props?.opensharechat) {
      getUsers();
    }
  }, [props?.opensharechat]);

  useEffect(() => {
    //auto generate link when status changes to public
    if (status === "public") {
      setChecked([]);
      generateLink();
    }
  }, [allUsers, status]);

  useEffect(() => {
    // When checked changes, allow the link to be regenerated
    setLinkGenerated(false);
    if (checked.length > 0 && status === "private") {
      generateLink();
    }
  }, [checked, status]);

  return (
    <>
      <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <Modal open={props.opensharechat} onClose={props.handleClosesharechat} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box className=" commonpopup  modal-common popup-w50">
        
            <div className="card-item__content ">
              <div class="card-title">
                <h2>{status === "public" ? "Share chat with public" : "Share chat privately"}</h2>
                <span>{status === "public" ? "Anybody accessing the link can view the chat" : "Your name and any messages you add after sharing stays private"}</span>
              </div>
              <Link className="close" onClick={props.handleClosesharechat}>
                X
              </Link>
            </div>
            <div className="modal-body">
            <div className="popup_scroller">

            <div className="share_chat_body">
              <div className="copy_chat_link">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="switchlanguage">
                      <div className="d-flex align-items-center justify-content-center mb-3">
                        <span className={status === "private" ? "text-success" : ""}>Private</span>
                        <Tooltip className="blue-tooltip" title="Change Privacy" TransitionComponent={Zoom} placement="bottom" arrow>
                          <FormControlLabel
                            className="m-0"
                            size="small"
                            control={<IOSSwitch size="small" sx={{ m: 1 }} fontSize="small" checked={status === "public"} onChange={handlePrivacyToggle} />}
                            // label={props?.browserMode ? "Browser" : "Brain"}
                          />
                        </Tooltip>
                        <span className={status === "public" ? "text-success" : ""}>Public</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <div className="copylink">
                        <TextField
                          id="outlined-basic"
                          type="text"
                          value={getTruncatedText(shareLink, 50)}
                          defaultValue="https://chatwise.ai/register/70fa5188-ee46-48ce-b3ab-e76dcd179b8e"
                          placeholder="Obtain the link by clicking on the 'Generate link' button below"
                          disabled={!linkGenerated}
                        />
                        <div className="copyicon" style={{ backgroundColor: "transparent" }}>
                          <button type="button" className="btn btn-primary" disabled={!linkGenerated} onClick={copyLink}>
                            <InsertLinkOutlinedIcon style={{ fontSize: "18px", marginRight: "5px" }} />
                            Copy link
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {status === "private" && (
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Share chat to people</label>

                        <div className="share_chat_people">
                          <div className="search_people">
                            <Autocomplete
                              disablePortal
                              multiple
                              id="combo-box-demo"
                              options={allUsers}
                              onChange={(event, value) => handleToggle(value)}
                              className="selectoption"
                              renderInput={(params) => <TextField {...params} placeholder="e.g. john@gmail.com" />}
                            />
                          </div>

                          {/* <List
                          className="block"
                          dense
                          sx={{
                            width: "100%",
                            backgroundColor: "#fafafa",
                            borderRadius: "10px",
                            maxHeight: "400px",
                            overflow: "auto",
                          }}
                        >
                          {allUsers.map((value) => {
                            const labelId = `checkbox-list-secondary-label-${value}`;
                            return (
                              <ListItem
                                key={value.id}
                                secondaryAction={
                                  <Checkbox
                                    edge="end"
                                    onChange={handleToggle(value.id)}
                                    checked={checked.indexOf(value) !== -1}
                                    inputProps={{ "aria-labelledby": labelId }}
                                  />
                                }
                                disablePadding
                              >
                                <ListItemButton>
                                  <ListItemAvatar>
                                    <Avatar
                                      sx={{
                                        width: "30px",
                                        height: "30px",
                                        backgroundColor: "#00bdd6",
                                      }}
                                      alt={`Avatar n°${value + 1}`}
                                      src={`/static/images/avatar/${
                                        value + 1
                                      }.jpg`}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText
                                    id={labelId}
                                    primary={`Harsh Sharma`}
                                  />
                                </ListItemButton>
                              </ListItem>
                            );
                          })}
                        </List> */}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* <div className="col-md-12">
                    <div className="form-group text-center">
                      <button type="button" className="btn btn-primary w-50" disabled={linkGenerated} onClick={generateLink}>
                        Generate link
                      </button>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}
